"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_ALL_PRODUCTS_PATHWAY = exports.GET_BENEFITS_BY_VARIANT_SKU = exports.GET_ADDONS_BY_VARIANT_SKU = exports.GET_PRODUCTS_BY_TYPE = exports.GET_MEMBERSHIP_SKUS_WITH_BENEFITS = exports.GET_PRODUCTS_BY_TYPE_FLAT_CARDS = exports.CANCEL_STANDING_ORDER = exports.ACCESS_VITALSOURCE_PRODUCT = exports.ACCESS_MERIDIAN_PRODUCT = exports.GET_PRODUCTS_LIST_DATA = exports.GET_PRODUCTS_ITEMS = exports.GET_PRODUCT_ITEM = void 0;
exports.GET_PRODUCT_ITEM = `
  query getProductBySlugOrSku($slug: String, $sku: String) {
    getProductBySlugOrSku(slug: $slug, sku: $sku)
  }
`;
exports.GET_PRODUCTS_ITEMS = `
  query getProductsBySlugs($slug: [String], $isPublished: Boolean) {
    getProductsBySlugs(slug: $slug, isPublished: $isPublished)
  }
`;
exports.GET_PRODUCTS_LIST_DATA = `
  query getProductsListData($orderNumber: String, $orgId: String) {
    getProductsListData(orderNumber: $orderNumber, orgId: $orgId)
  }
`;
exports.ACCESS_MERIDIAN_PRODUCT = `
{
  accessMeridianProduct {
    url
  }
}
`;
exports.ACCESS_VITALSOURCE_PRODUCT = `
  query accessVitalSourceProduct($vbid: String) {
    accessVitalSourceProduct(vbid: $vbid) {
      url
    }
  }
`;
exports.CANCEL_STANDING_ORDER = `
  mutation cancelStandingOrder($orderNumber: String, $productId: String, $sku: String) {
    cancelStandingOrder(orderNumber: $orderNumber, productId: $productId, sku: $sku) {
      success
    }
  }
`;
exports.GET_PRODUCTS_BY_TYPE_FLAT_CARDS = `
  query ($type: String) {
    getProductsByType(type: $type, flatCards: true)
  }
`;
exports.GET_MEMBERSHIP_SKUS_WITH_BENEFITS = `
  query getMembershipTiers($productSlug: String, $isFLP: Boolean) {
    getMembershipTiers(productSlug: $productSlug, isFLP: $isFLP)
  }
`;
exports.GET_PRODUCTS_BY_TYPE = `
  query getProductsByType($type: String) {
    getProductsByType(type: $type, flatCards: false)
  }
`;
exports.GET_ADDONS_BY_VARIANT_SKU = `
  query getAddonsByVariantSku($memberTypeTierSkuPrefix: String, $cimaEntryLevel: String) {
    getAddonsByVariantSku(memberTypeTierSkuPrefix: $memberTypeTierSkuPrefix, cimaEntryLevel: $cimaEntryLevel)
  }
`;
exports.GET_BENEFITS_BY_VARIANT_SKU = `
  query getBenefitsByVariantSku($sku: String!, $grouped: Boolean, $isDelayedBenefit: Boolean) {
    getBenefitsByVariantSku(sku: $sku, grouped: $grouped, isDelayedBenefit: $isDelayedBenefit )
  }
`;
exports.GET_ALL_PRODUCTS_PATHWAY = `
  query getAllPathwayProducts($isChinesePathway: Boolean) {
    getAllPathwayProducts(isChinesePathway: $isChinesePathway)
  }
`;
//# sourceMappingURL=products-queries.js.map